/**
 * @huyafed/web-signal-sdk API
 * https://git.huya.com/webmiddle/project-components/web-signalSdk
 */

/* eslint-disable new-cap */
import TafSdk from '@huyafed/web-signal-sdk';

function getCooike(key, def) {
  const cookie = document.cookie
  if (!cookie) return def
  const temp = {}
  cookie.split(';').forEach(str => {
    const val = str.trim().split('=')
    temp[val[0]] = val[1]
  })
  return temp[key] || def;
}

const signalSdk = new TafSdk.init({
  appSrc: 'HUYA&ZH&2052',
  APPID: 'HUYA',
  ua: 'hyextstore&1.0.0&huya', // 平台&版本&渠道&系统版本号
  uid: getCooike('udb_uid', '0'),
  isDebug: process.env.HUYA_APP_ENV === 'production' ? 0 : 1,  // 是否测试环境
  noConnect: 1, // 是否建立长连接
});

const Taf = signalSdk.getTaf()
window.Taf = Taf

/**
 * @typedef {Object} BufferInfo
 * @property {Object} data 原始数据
 * @property {string} path 数据位置
 * @property {Object} parent 上层数据
 */
/**
 * 二进制读取方式
 * @callback ReadBufferCallback
 * @param {BufferInfo} bufferInfo 需要读取的信息
 */
/**
 * @typedef {Object} RenderDataOptions
 * @property {ReadBufferCallback} readBuffer 处理二进制读取
 */
/**
 * 数据处理
 * @param {Object} data 数据
 * @param {RenderDataOptions} [opt] 配置
 * @param {string} [parent] 上级
 * @returns {Object}
 */
function renderData(data, opt = {}, parent) {
  if (!data) return data;
  const temp = {}

  Object.keys(data).forEach(key => {
    const val = data[key]
    const path = parent ? `${parent}.${key}` : key
    switch (true) {
      case val instanceof Taf.Vector:
        temp[key] = val.value ? val.value.map((val, i) => renderData(val, opt, `${path}.${i}`)) : val.value
        break;
      case val instanceof Taf.Map:
        temp[key] = renderData(val.value, opt, path)
        break;
      case val instanceof Taf.BinBuffer:
        const { readBuffer } = opt || {}
        if (!readBuffer) {
          temp[key] = val;
          break;
        }
        const readData = readBuffer({ data: val, path, parent: data })
        temp[key] = renderData(readData, opt, path)
        break;
      case val && typeof val === 'object':
        temp[key] = renderData(val, opt, path);
        break;
      default:
        temp[key] = val
    }
  })
  return temp;
}

/**
 * 二进制数据读取
 * @param {Object} msg 数据
 * @param {Object} RspClass 结构类
 * @returns {Object} 返回
 */
export function readBinBuffer(msg, RspClass) {
  const is = new Taf.JceInputStream(msg);
  const rsp = new RspClass();
  rsp.readFrom(is);
  return rsp;
}

/**
 * @typedef {Object} WupParams
 * @property {string} servantName ui
 * @property {string} funcName funcName
 * @property {Object} req 参数
 * @property {Object} rspClass 返回类
 * @property {number} [tryCount] 重试次数
 * @property {RenderDataOptions} [readConfig] 读取数据配置
 */
/**
 * 发送wup请求
 * @param {WupParams} param
 * @returns
 */
export function sendWup(param) {
  const {
    servantName,
    funcName,
    req,
    tryCount = 1,
    rspClass,
    readConfig,
  } = param || {}

  return new Promise((resolve, reject) => {
    console.log('sendWup start', param);
    signalSdk.registerWup(funcName, rspClass);
    signalSdk.sendWup(servantName, funcName, req, (data) => {
      try {
        const res = renderData(data, readConfig)
        console.log('sendWup success', res)
        resolve(res)
      } catch (err) {
        console.warn('sendWup fail', err, data)
        reject(err)
      }
    }, tryCount)
  })
}

export function getUserId() {
  return signalSdk.getUserId();
}

export default signalSdk
